import { render, staticRenderFns } from "./OrderDetails.vue?vue&type=template&id=17ca766a&scoped=true&"
import script from "./OrderDetails.vue?vue&type=script&lang=js&"
export * from "./OrderDetails.vue?vue&type=script&lang=js&"
import style1 from "./OrderDetails.vue?vue&type=style&index=1&id=17ca766a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ca766a",
  null
  
)

export default component.exports